<template>
    <div class="modal medium-modal">
		<div class="inner">
			<h2>{{ listDetail.product_price_override_id  ? 'Edit' : 'Add' }} a Price Override</h2>
			<div class="content">
				<div class="one-two-columns" style="margin: 0 0 1em 0;">
					<div style="position: relative; text-align: center;">
						<img :src="listDetail.image_src.replace('tiny', 'small')" style="max-height: 8em;">
						<img v-if="listDetailLocal.display_flag" :src="'https://dataconnectservices.com/images/sale-badge-' + listDetailLocal.display_flag + '.png'" style="position: absolute; top: 0; right: 0; width: 11em;">

						<div style="margin: 1em 0 0 0;">
							<label>UPC</label> <b>{{ listDetailLocal.upc }}</b>
						</div>
					</div>
					<div>
						<div class="title">{{ listDetailLocal.short_description || listDetailLocal.description }}</div>
						<div class="two-one-columns">
							<div>
								<label class="full">Department</label>
								<div><b>{{ listDetailLocal.department }}</b></div>
								<label class="full space-before">Category</label>
								<div><b>{{ listDetailLocal.category }}</b></div>
								<label class="full space-before">Manufacturer</label>
								<div><b>{{ listDetailLocal.manufacturer }}</b></div>
								<label class="full space-before">MSRP</label>
								<div><b>{{ productInventory.msrp > 0 ? productInventory.msrp : 'N/A' }}</b></div>
							</div>
							<div>
								<label class="full">Available</label>
								<div><b>{{ productInventory.available || productInventory.on_hand }}</b></div>
								<label class="full space-before">Cost</label>
								<div><b>{{ productInventory.cost || 'N/A' }}</b></div>
								<label class="full space-before">Price</label>
								<div><b>{{ (getGlobalSource == 'WEBSITE' ? productInventory.web_price : productInventory.price) || 'N/A' }}</b></div>
								<label class="full space-before">MAP</label>
								<div><b>{{ productInventory.map > 0 ? productInventory.map : 'N/A' }}</b></div>
							</div>
						</div>
					</div>
				</div>
				<div class="three-columns">
					<div>
						<label>Override Price</label>
						<number-input :decimals='2' v-model="listDetailLocal.price" :key="'price_' + listDetailLocal.price" />
					</div>
					<div>
						<label>Start</label>
						<input type="date" v-model="listDetailLocal.start_date" />
					</div>
					<div>
						<label>End</label>
						<input type="date" v-model="listDetailLocal.end_date" />
					</div>
					<div>
						<label>Flag</label>
						<select v-model="listDetailLocal.display_flag">
							<option v-for="(flag, index) in priceOverrideFlagsLocal" :value="index">{{ flag }}</option>
						</select>
					</div>
					<div>
						<label>Use For</label>
						<select v-model="listDetailLocal.product_price_override_type_id">
							<option value="">Select...</option>
							<option v-for="(type, index) in priceOverrideTypesLocal" :value="type.product_price_override_type_id">{{ type.description }}</option>
						</select>
					</div>
					<div>
						<label>Note</label>
						<input type="text" v-model="listDetailLocal.notes" />
					</div>
				</div>
				<div class="message-overlay" v-if="saveMessage">
					<p v-html="saveMessage"></p>
					<div class="empty"><i :class="['fa', saveSuccess ? 'fa-check' : 'fa-ban']" /></div>
				</div>
				<div class="message-overlay" v-if="confirmDelete">
					<p>Are you sure you want to delete this price override?</p>
					<div style="font-size: 0.8em;">
						<div class="button cancel spaced" @click="cancelItem()">Cancel</div>
						<div class="button delete spaced" @click="deleteItem()">Yes, Delete</div>
					</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="cancelItem()">Cancel</div>
				<div v-if="listDetail.product_price_override_id" :class="['button', saving ? 'disabled' : 'neutral', 'spaced']" @click="confirmDelete = true">Delete</div>
				<div :class="['button', 'spaced', saving || !listDetailLocal.product_price_override_type_id || (!listDetailLocal.price && !listDetailLocal.display_flag) ? 'disabled' : 'action']" @click="saveItem()">Save Price Override</div>
			</div>
		</div>
    </div>
</template>
<script>
import NumberInput from '@/components/NumberInput.vue'
export default {
    name: 'price-override-detail',
    props: {
        listDetail: {
            type: Object,
			default() {
            	return {}
        	}
		},
        priceOverrideTypes: {
            type: Array,
			default() {
            	return []
        	}
		},
        priceOverrideFlags: {
            type: Array,
			default() {
            	return []
        	}
        }
    },
    components: {
		'number-input': NumberInput
    },
	data() {
		return {
			saving: false,
			saveMessage: '',
			saveSuccess: false,
			confirmDelete: false,
			listDetailLocal: {},
			priceOverrideTypesLocal: [],
			priceOverrideFlagsLocal: [],
			productInventory: {}
		}
	},
    created() {
		if (this.listDetail.product_price_override_id) {
			this.listDetailLocal = JSON.parse(JSON.stringify(this.listDetail))
		} else {
			this.getPriceOverride()
		}
		this.getProductInventory()
		if (this.priceOverrideTypes.length == 0 || this.priceOverrideFlags.length == 0) {
			this.getControlLists()
		} else {
			this.priceOverrideTypesLocal = this.priceOverrideTypes
			this.priceOverrideFlagsLocal = this.priceOverrideFlags
		}
    },
    watch: {
	},
	methods: {
		getPriceOverride() {
			this.apiCall({ destination: 'get_item_price_override', data: { product_price_override_id: this.listDetail.product_price_override_id, product_id: this.listDetail.product_id } }).then(obj => {
				//this.listDetailLocal.price = ''
				this.listDetailLocal.product_price_override_type_id = ''
				this.listDetailLocal.display_flag = 0
				if (obj.status == 'success') {
					// spread operator ... iterates objects 
					this.listDetailLocal = {
						...this.listDetailLocal,
						...obj.price_override,
						...this.listDetail
					}
					this.listDetailLocal.price = obj.price_override.price
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getProductInventory() {
			this.apiCall({ destination: 'get_item_product_inventory', data: { product_id: this.listDetail.product_id } }).then(obj => {
				if (obj.status == 'success') {
					this.productInventory = obj.inventory
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getControlLists() {
			this.apiCall({ destination: 'get_price_override_control_lists' }).then(obj => {
				this.priceOverrideDepartments = obj.price_override_departments
				this.priceOverrideTypesLocal = obj.price_override_types
				this.priceOverrideFlagsLocal = obj.price_override_flags
			}).catch(err => {
				console.log(err)
			})
		},
		saveItem() {
			if (this.saving) { return }
			if (!this.listDetailLocal.product_price_override_type_id && !this.listDetailLocal.price && !this.listDetailLocal.display_flag) { 
				this.saveMessage = 'Overried Price OR Flag are required,<br>along with a Use For selection.'
				setTimeout(() => { this.saveMessage = '' }, 2500);
				return 
			}
			this.saveSuccess = false
			this.saving = true
			this.saveMessage = 'Saving price override...'
			this.apiCall({ destination: 'save_item_price_override', data: this.listDetailLocal }).then(obj => {
				if (obj.status == 'success') {
					this.saveSuccess = true
					this.saveMessage = 'Price override saved!'
					setTimeout(() => {
						this.$emit('backToList', true) // parent updateRequired = true
						this.saveMessage = ''
					}, 2000);
				} else {
					this.saveMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		deleteItem() {
			if (this.saving) { return }
			this.saving = true
			this.confirmDelete = false
			this.saveMessage = 'Deleting price override...'
			this.apiCall({ destination: 'save_item_price_override', data: { product_price_override_id: this.listDetail.product_price_override_id, delete: true } }).then(obj => {
				if (obj.status == 'success') {
					this.saveSuccess = true
					this.saveMessage = 'Price override deleted!'
					setTimeout(() => {
						this.$emit('backToList', true) // parent updateRequired = true
						this.saveMessage = ''
					}, 2000);
				} else {
					this.saveMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
        cancelItem() {
            this.saveMessage = ''
            this.$emit('backToList', false) // parent updateRequired = false
        }
    }
}
</script>
